var CartDiscountType = /* @__PURE__ */ ((CartDiscountType2) => {
  CartDiscountType2["PERCENT"] = "PERCENT";
  CartDiscountType2["AMOUNT"] = "AMOUNT";
  return CartDiscountType2;
})(CartDiscountType || {});
export {
  CartDiscountType
};
//# sourceMappingURL=types.js.map
